const productionConfig = {
    "PORT": 8080,
    "BASE_URL": "https://ifincredit.ifingate.com",
    "REACT_APP_API_URL": "https://ifincredit-api.ifingate.com",
    "APP_IFINGATE": "https://app.ifingate.com",
    "APP_IFINPULSE": "https://app.ifinpulse.com",
    "APP_IFINHEALTH": "https://app.ifinhealth.com"
};

export default productionConfig;
